export const languageKey = 'i18nextLng';
